import { render, staticRenderFns } from "./SiteAction.vue?vue&type=template&id=8d06e186"
import script from "./SiteAction.vue?vue&type=script&lang=js"
export * from "./SiteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports